interface Props {
  title: string;
  description: string;
  checked: boolean;
  onChange?: () => void;
  disabled?: boolean;
}

const ToggleSwitch = ({ title, description, checked, onChange = () => { }, disabled }: Props) => {

  return (
    <div
      className="flex flex-row-reverse gap-3 justify-between md:block"
      onClick={e => {
        e.preventDefault();
        onChange();
      }}
    >
      <div className="flex items-center mb-3 ml-1">
        <label className="inline-flex relative items-center cursor-pointer">
          <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            className="sr-only peer"
          />
          <div className="w-10 h-6 bg-[#D6D6D6] rounded-full peer peer-checked:bg-[#004de3] peer-disabled:bg-opacity-30 relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:w-5 after:h-5 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-4" />
        </label>
      </div>

      <div className='flex gap-10 justify-between items-center'>
        <div className="flex flex-col">
          <h2 className="mb-2 font-bold text-black text-md">{title}</h2>
          <p className="text-xs text-gray-500 md:text-sm">
            {description}
          </p>
        </div>

      </div>
    </div>
  );
};

export default ToggleSwitch;
